export class PermissionDetails {
    constructor(public activity: string, public displayName: string, public isEnabled: boolean) {
    }
}


/** WEBPACK FOOTER **
 ** ./app/main/accessManagement/permission-details.ts
 **/